if (!customElements.get('vs-variant-selects')) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);

      /* Delegación estable: un click sobre cualquier variante siempre fuerza
         la actualización, incluso si esa opción ya estaba seleccionada.
         Esto corrige el caso de la primera variante al cargar la página. */
      this.addEventListener('click', (event) => {
        const label = event.target.closest && event.target.closest('label.vs-pdp__variant');
        if (!label || !this.contains(label)) return;

        const inputId = label.getAttribute('for');
        if (!inputId) return;

        let input = null;
        try {
          input = this.querySelector('#' + CSS.escape(inputId));
        } catch (e) {
          input = document.getElementById(inputId);
        }
        if (!input) return;

        event.preventDefault();

        if (input.disabled || input.dataset.available === 'false') return;

        /* Marcamos manualmente y lanzamos change SIEMPRE.
           Así funciona la primera, la última y cualquier cantidad de variantes. */
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      this.other = Array.from(document.querySelectorAll('vs-variant-selects')).filter((selector) => selector != this);
      this.productWrapper = this.closest('.thb-product-detail') || this.closest('vs-pdp-product');
      this.productSlider = this.productWrapper.querySelector('.product-images') || this.productWrapper.querySelector('vs-product-slider');
      this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
      this.hideVariants = this.dataset.hideVariants === 'true';
      this.addEventListener('mousedown', (e) => {
        if (e.target.tagName === 'LABEL') {
          const scrollY = window.scrollY;
          requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: 'instant' }));
        }
      });
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();

      requestAnimationFrame(() => {
        const initialVariant = this.resolveVariantIdFromOptions();
        if (initialVariant) {
          const record = this.getVariantRecord(initialVariant.id);
          const mediaId = record ? parseInt(record.dataset.mediaId, 10) : null;

          this.currentVariant = {
            id: Number(initialVariant.id),
            available: record ? record.dataset.available === 'true' : !!initialVariant.available,
            featured_media: mediaId ? { id: mediaId } : null,
          };

          this.updateVariantInput();
          this.updateMedia();
        }

        this.setupReferenceVariantModal();
        this.syncReferenceVariantModal();
      });
    }

    setupReferenceVariantModal() {
      if (this.__vsVrefReady) return;
      this.__vsVrefReady = true;

      this.vrefModal = this.querySelector('[data-vs-vref-modal]');
      this.vrefOpen = this.querySelector('[data-vs-vref-open]');
      this.vrefTriggerLabel = this.querySelector('[data-vs-vref-trigger-label]');
      this.vrefAdd = this.querySelector('[data-vs-vref-add]');
      this.vrefHeart = this.querySelector('[data-vs-vref-heart]');
      this.vrefView = this.querySelector('[data-vs-vref-view]');
      this.vrefRows = Array.from(this.querySelectorAll('[data-vs-vref-row]'));

      if (!this.vrefModal || !this.vrefOpen) return;

      this.vrefOpen.addEventListener('click', () => this.openReferenceVariantModal());

      this.querySelectorAll('[data-vs-vref-close]').forEach((button) => {
        button.addEventListener('click', () => this.closeReferenceVariantModal());
      });

      this.vrefRows.forEach((row) => {
        row.addEventListener('click', () => {
          if (row.getAttribute('aria-disabled') === 'true' || row.dataset.available === 'false') return;
          this.selectReferenceVariantRow(row);
        });
      });

      if (this.vrefAdd) {
        this.vrefAdd.addEventListener('click', () => {
          if (this.vrefAdd.disabled || this.vrefAdd.classList.contains('is-loading')) return;
          if (!this.currentVariant || !this.currentVariant.id) return;
          if (!this.productWrapper || typeof this.productWrapper.addToCart !== 'function') return;

          const qtyInput = this.productWrapper.querySelector('[data-vs-qty-input]');
          const quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

          this.productWrapper
            .addToCart(this.vrefAdd, this.currentVariant.id, quantity)
            .then(() => this.closeReferenceVariantModal())
            .catch(() => {});
        });
      }

      if (this.vrefHeart) {
        this.vrefHeart.addEventListener('click', () => {
          const mainHeart = this.productWrapper && this.productWrapper.querySelector('[data-vs-wishlist]');
          if (!mainHeart) return;
          mainHeart.click();
          requestAnimationFrame(() => this.syncReferenceVariantModal());
        });
      }

      if (this.vrefView) {
        this.vrefView.addEventListener('click', () => {
          if (this.vrefView.classList.contains('is-confirming')) return;

          this.vrefView.classList.add('is-confirming');
          this.vrefView.disabled = true;

          window.setTimeout(() => {
            this.closeReferenceVariantModal();

            window.setTimeout(() => {
              this.vrefView.classList.remove('is-confirming');
              this.vrefView.disabled = false;
            }, 260);
          }, 260);
        });
      }

      this.__vsVrefEscape = (event) => {
        if (event.key === 'Escape' && this.vrefModal.classList.contains('is-open')) {
          this.closeReferenceVariantModal();
        }
      };
      document.addEventListener('keydown', this.__vsVrefEscape);
    }

    disconnectedCallback() {
      if (this.__vsVrefEscape) document.removeEventListener('keydown', this.__vsVrefEscape);
      document.documentElement.classList.remove('vs-vref-open');
      document.body.classList.remove('vs-vref-open');
    }

    openReferenceVariantModal() {
      if (!this.vrefModal) return;

      this.syncReferenceVariantModal();
      document.documentElement.classList.add('vs-vref-open');
      document.body.classList.add('vs-vref-open');

      this.vrefModal.classList.add('is-open');
      this.vrefModal.setAttribute('aria-hidden', 'false');
      this.vrefOpen.setAttribute('aria-expanded', 'true');

      requestAnimationFrame(() => {
        const close = this.vrefModal.querySelector('.vs-pdp__vref-close');
        if (close) close.focus({ preventScroll: true });
      });
    }

    closeReferenceVariantModal() {
      if (!this.vrefModal) return;

      this.vrefModal.classList.remove('is-open');
      this.vrefModal.setAttribute('aria-hidden', 'true');
      this.vrefOpen.setAttribute('aria-expanded', 'false');

      document.documentElement.classList.remove('vs-vref-open');
      document.body.classList.remove('vs-vref-open');

      requestAnimationFrame(() => {
        if (this.vrefOpen) this.vrefOpen.focus({ preventScroll: true });
      });
    }

    selectReferenceVariantRow(row) {
      if (!row) return;
      if (row.getAttribute('aria-disabled') === 'true' || row.dataset.available === 'false') return;

      const values = [
        row.dataset['option-1'] || row.getAttribute('data-option-1') || '',
        row.dataset['option-2'] || row.getAttribute('data-option-2') || '',
        row.dataset['option-3'] || row.getAttribute('data-option-3') || ''
      ];

      const fieldsets = Array.from(this.querySelectorAll('.vs-pdp__variant-native fieldset'));
      let lastChangedInput = null;

      fieldsets.forEach((fieldset, index) => {
        const wanted = values[index];
        if (!wanted) return;

        const input = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
          .find((radio) => radio.value === wanted);

        if (input) {
          input.checked = true;
          lastChangedInput = input;
        }
      });

      /* El change usa la lógica REAL existente:
         actualiza título, precio, stock, formularios y la imagen
         asociada a la variante antes de cerrar la ventana. */
      if (lastChangedInput) {
        lastChangedInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        this.updateOptions();
        this.renderVariantInfo();
      }

      const chosenName = row.querySelector('.vs-pdp__vref-name');
      if (this.vrefTriggerLabel && chosenName) {
        const label = chosenName.textContent.trim();
        if (label) {
          this.vrefTriggerLabel.textContent = label;
          this.vrefOpen.dataset.vsVariantSelected = 'true';
        }
      }

      this.syncReferenceVariantModal();
      this.closeReferenceVariantModal();
    }

    syncReferenceVariantModal() {
      if (!this.vrefRows || !this.vrefRows.length) return;

      const selectedVariant = this.resolveVariantIdFromOptions();
      const selectedId = selectedVariant ? String(selectedVariant.id) : '';

      let selectedRow = null;

      this.vrefRows.forEach((row) => {
        const selected = row.dataset.variantId === selectedId;
        row.setAttribute('aria-selected', selected ? 'true' : 'false');
        if (selected) selectedRow = row;
      });

      if (
        selectedRow &&
        this.vrefOpen &&
        this.vrefOpen.dataset.vsVariantSelected === 'true' &&
        this.vrefTriggerLabel
      ) {
        const selectedName = selectedRow.querySelector('.vs-pdp__vref-name');
        if (selectedName && selectedName.textContent.trim()) {
          this.vrefTriggerLabel.textContent = selectedName.textContent.trim();
        }
      }

      if (this.vrefAdd) {
        this.vrefAdd.disabled = !(this.currentVariant && this.currentVariant.available);
      }

      if (this.vrefHeart && this.productWrapper) {
        const mainHeart = this.productWrapper.querySelector('[data-vs-wishlist]');
        if (mainHeart) {
          const active = mainHeart.classList.contains('is-active') || mainHeart.getAttribute('aria-pressed') === 'true';
          this.vrefHeart.classList.toggle('is-active', active);
          this.vrefHeart.setAttribute('aria-pressed', active ? 'true' : 'false');
        }
      }
    }

    onVariantChange(e) {
      this.updateOptions();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();

      /* La combinación COMPLETA elegida es la única fuente de verdad.
         No cargamos aquí el span anterior porque todavía contiene la variante vieja. */
      this.renderVariantInfo();
      this.updateOther();
    }

    updateMediaFromInput(e) {
      if (!e || !e.target) return;
      const input = e.target.closest('input, select, option') || e.target;
      let mediaId;
      if (input.tagName === 'SELECT') {
        const selected = input.selectedOptions[0];
        mediaId = selected && selected.dataset.featuredMediaId;
      } else {
        mediaId = input.dataset.featuredMediaId;
      }
      if (!mediaId) return;
      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
      this.setActiveMedia(`#Slide-${this.dataset.section}-${mediaId}`, `[data-pm-media="${this.dataset.section}-${mediaId}"]`, this.productSlider, thumbnails);
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];

      this.fieldsets.forEach((fieldset) => {
        const select = fieldset.querySelector('select');
        if (select) {
          this.options.push(select.value);
          return;
        }

        const checked = fieldset.querySelector('input:checked');
        if (checked) this.options.push(checked.value);
      });
    }

    updateVariantText() {
      Array.from(this.querySelectorAll('fieldset')).forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) label.innerHTML = this.options[i];
      });
    }

    updateMasterId() {
      const span = this.querySelector(`#SelectedVariant-${this.dataset.section}`);
      if (span) {
        this.currentVariant = {
          id: parseInt(span.dataset.variantId, 10) || null,
          available: span.dataset.available === 'true',
          featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null,
        };
      }
    }

    updateOther() {
      if (this.dataset.updateUrl !== 'false' && this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset');
        let fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          fieldsets_array[i].querySelector('select')
            ? (fieldsets_array[i].querySelector('select').value = option)
            : fieldsets_array[i].querySelectorAll('input').length && (fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true);
        });
        this.other[0].updateOptions();
        this.other[0].updateVariantText();
        this.other[0].renderVariantInfo();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant || !this.currentVariant.featured_media) return;
      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
      this.setActiveMedia(
        `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        `[data-pm-media="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
        this.productSlider,
        thumbnails
      );
    }

    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      if (!productSlider) return;
      let flkty = productSlider.flkty;
      let activeMedia = null;
      try { activeMedia = productSlider.querySelector(mediaId); } catch (e) {}

      if (!activeMedia) {
        const rawMediaId = String(mediaId).split('-').pop();
        activeMedia = productSlider.querySelector('[data-media-id$="-' + rawMediaId + '"]')
          || productSlider.querySelector('[id$="-' + rawMediaId + '"]');
        if (!activeMedia) {
          console.warn('VS PDP: no se encontró el slide para', mediaId);
          return;
        }
      }

      if (activeMedia && typeof productSlider.vsDesktopSelect === 'function' && window.matchMedia('(min-width: 900px)').matches) {
        /* Controlador desktop estable: cambia la imagen sin depender de Flickity. */
        productSlider.vsDesktopSelect(mediaId);
      } else if (flkty && activeMedia) {
        productSlider.selectCell(mediaId);
      } else if (activeMedia && typeof productSlider.selectCell === 'function') {
        productSlider.selectCell(mediaId);
      } else if (activeMedia) {
        try {
          activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        } catch (e) {
          activeMedia.scrollIntoView();
        }
      }

      if (activeMedia) {
        productSlider.querySelectorAll('.product-images__slide.is-variant-selected').forEach((el) => {
          el.classList.remove('is-variant-selected');
        });
        activeMedia.classList.add('is-variant-selected');

        requestAnimationFrame(() => {
          const image = activeMedia.querySelector('.product-single__media-image > img');
          if (!image || typeof image.animate !== 'function' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (image.__vsVariantAnimation) {
            try { image.__vsVariantAnimation.cancel(); } catch (e) {}
          }
          image.__vsVariantAnimation = image.animate(
            [
              { opacity: .9, transform: 'scale(.995)' },
              { opacity: 1, transform: 'scale(1)' }
            ],
            { duration: 160, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'both' }
          );
        });
      }

      if (thumbnails && activeMedia) {
        const mediaKey = activeMedia.getAttribute('data-media-id');
        const activeThumb = mediaKey
          ? thumbnails.querySelector(`[data-media-id="${mediaKey}"]`)
          : null;

        thumbnails.querySelectorAll('.product-thumbnail.is-initial-selected').forEach((el) => {
          el.classList.remove('is-initial-selected');
        });
        if (activeThumb) activeThumb.classList.add('is-initial-selected');
      }

      if (this.currentVariant && this.currentVariant.featured_media && this.productWrapper) {
        const mobileId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        this.productWrapper.querySelectorAll('.pm-mthumbs__item').forEach((el) => {
          el.classList.toggle('is-active', el.getAttribute('data-pm-media') === mobileId);
        });
      }
    }

    updateVariantInput() {
      if (!this.productWrapper || !this.currentVariant) return;
      this.productWrapper.querySelectorAll('[data-vs-selected-variant-id], form input[name="id"]').forEach((input) => {
        const target = input.matches && input.matches('input') ? input : null;
        if (!target) return;
        target.value = this.currentVariant.id;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    removeErrorMessage() {
      const section = this.closest('section') || this.closest('vs-pdp-product');
      if (!section) return;
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `inventory-${this.dataset.section}`];
    }

    getSelectedValueIds() {
      return this.fieldsets
        .map((fieldset) =>
          fieldset.querySelector('select')
            ? fieldset.querySelector('select').selectedOptions[0]?.dataset.valueId
            : fieldset.querySelector('input:checked')?.dataset.valueId
        )
        .filter(Boolean);
    }

    /* ADAPTACIÓN NECESARIA Y SEÑALADA: el tema original resuelve la variante
       coincidente en el servidor a partir de ?option_values=<ids>. El snippet
       Liquid que hace esa resolución no vino incluido en el material entregado,
       así que no puedo reproducirlo sin inventarlo. En su lugar, calculamos aquí
       mismo (con los datos reales de product.variants ya presentes en la página)
       el ID de la variante que coincide con las opciones elegidas, y usamos el
       parámetro ?variant=<id> — mecanismo nativo y documentado de Shopify que
       sí actualiza product.selected_or_first_available_variant en el servidor.
       El resto del flujo (fetch real, re-render de precio/inventario desde HTML
       devuelto por Shopify, actualización de disponibilidad) es exactamente el
       original. */
    resolveVariantIdFromOptions() {
      const selects = (this.closest('vs-pdp-product') ? this.closest('vs-pdp-product').querySelector('[id^="product-select-json-"]') : document.querySelector('[id^="product-select-json-"]'));
      if (!selects) return null;
      let variants;
      try {
        variants = JSON.parse(selects.textContent);
      } catch (e) {
        return null;
      }
      const match = variants.find((variant) => {
        const opts = [variant.option1, variant.option2, variant.option3].filter((o) => o !== null);
        return opts.every((opt, i) => opt === this.options[i]);
      });
      return match || null;
    }

    getVariantRecord(variantId) {
      if (!variantId) return null;
      return this.querySelector(`[data-vs-variant-record="${variantId}"]`);
    }

    animateVariantNode(node, keyframes) {
      if (!node || typeof node.animate !== 'function' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (node.__vsVariantAnimation) {
        try { node.__vsVariantAnimation.cancel(); } catch (e) {}
      }
      node.__vsVariantAnimation = node.animate(
        keyframes || [
          { opacity: .86, transform: 'translateY(1px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ],
        { duration: 120, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'both' }
      );
    }

    animateSelectedVariantControl() {
      const selected = this.querySelector('.vs-pdp__variant-radio:checked + .vs-pdp__variant');
      if (!selected || typeof selected.animate !== 'function' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (selected.__vsVariantAnimation) {
        try { selected.__vsVariantAnimation.cancel(); } catch (e) {}
      }
      selected.__vsVariantAnimation = selected.animate(
        [
          { transform: 'scale(.985)' },
          { transform: 'scale(1.012)' },
          { transform: 'scale(1)' }
        ],
        { duration: 150, easing: 'cubic-bezier(.2,.8,.2,1)' }
      );
    }

    applyVariantPresentation(targetVariant, record) {
      if (!targetVariant || !record) return;

      const titleEl = this.productWrapper.querySelector('[data-vs-dynamic-title]');
      const infoEl = this.productWrapper.querySelector('[data-vs-dynamic-info]');
      const priceBlock = this.productWrapper.querySelector('[data-vs-price]');
      const priceCurrent = priceBlock ? priceBlock.querySelector('[data-vs-price-current]') : null;
      const priceCompare = priceBlock ? priceBlock.querySelector('[data-vs-price-compare]') : null;

      if (titleEl) {
        titleEl.textContent = record.dataset.title || targetVariant.title || '';
        this.animateVariantNode(titleEl);
      }

      if (priceCurrent) {
        priceCurrent.textContent = record.dataset.priceMoney || '';
      }

      if (priceCompare) {
        const price = Number(record.dataset.price || 0);
        const compare = Number(record.dataset.comparePrice || 0);
        if (compare > price) {
          priceCompare.textContent = record.dataset.compareMoney || '';
          priceCompare.hidden = false;
        } else {
          priceCompare.textContent = '';
          priceCompare.hidden = true;
        }
      }

      if (priceBlock) {
        this.animateVariantNode(priceBlock, [
          { opacity: .9, transform: 'translateY(1px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ]);
      }

      if (infoEl) {
        const template = record.querySelector('[data-vs-variant-info-template]');
        const html = template ? template.innerHTML.trim() : '';
        if (html) {
          infoEl.innerHTML = html;
          infoEl.hidden = false;
          this.animateVariantNode(infoEl);
        } else {
          infoEl.innerHTML = '';
          infoEl.hidden = true;
        }
      }

      /* Stock instantáneo: no espera respuesta del servidor. */
      const stockBlock = this.productWrapper.querySelector(`#inventory-${this.dataset.section}`);
      if (stockBlock) {
        const available = record.dataset.available === 'true';
        stockBlock.classList.toggle('vs-pdp__stock--out', !available);
        stockBlock.classList.remove('visibility-hidden');
        const stockLabel = stockBlock.querySelector('[data-vs-stock-label]');
        if (stockLabel) stockLabel.textContent = record.dataset.stockLabel || '';
      }

      /* Cuotas instantáneas manteniendo el mismo botón/link ya conectado. */
      const installmentMoney = record.dataset.installmentMoney || '';
      const installments = this.productWrapper.querySelector('[data-vs-installments]');
      if (installments && installmentMoney) {
        const strongs = installments.querySelectorAll('strong');
        if (strongs.length > 1) strongs[1].textContent = installmentMoney;

        const directLink = installments.querySelector('a[href*="/cart/"]');
        if (directLink) directLink.href = `/cart/${targetVariant.id}:1`;
      }

      /* También sincronizar el modal de cuotas sin reconstruirlo. */
      if (installmentMoney) {
        const modal = this.productWrapper.querySelector('[data-vs-payplan-modal]');
        if (modal) {
          const modalPrice = modal.querySelector('.vs-payplan-modal__desc strong');
          if (modalPrice) modalPrice.textContent = record.dataset.priceMoney || '';
          modal.querySelectorAll('.vs-payplan-modal__amount').forEach((el) => {
            el.textContent = installmentMoney;
          });
        }
      }

      this.animateSelectedVariantControl();
    }

    renderVariantInfo() {
      const targetVariant = this.resolveVariantIdFromOptions();

      if (!targetVariant) {
        this.currentVariant = null;
        this.toggleAddButton(true, window.theme.variantStrings.unavailable, true);
        this.setUnavailable();
        return;
      }

      const record = this.getVariantRecord(targetVariant.id);
      if (!record) return;

      const mediaId = parseInt(record.dataset.mediaId, 10) || null;
      const available = record.dataset.available === 'true';

      /* Toda la variante ya está renderizada en el HTML:
         no hay fetch, no hay espera y no existe un segundo cambio tardío. */
      this.currentVariant = {
        id: Number(targetVariant.id),
        available: available,
        featured_media: mediaId ? { id: mediaId } : null,
      };

      /* Un solo frame: texto, precio, información, stock, imagen y formularios. */
      this.applyVariantPresentation(targetVariant, record);
      this.updateVariantInput();
      this.updateMedia();
      this.toggleAddButton(
        !available,
        available ? false : window.theme.variantStrings.soldOut
      );
      this.setDisabled();

      this.syncReferenceVariantModal();

      window.dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const scope = this.productWrapper || this;
      const submitButtons = scope.querySelectorAll('.single-add-to-cart-button, [data-vs-add-btn]');
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text, [data-vs-add-label]');
        if (!submitButtonText) return;
        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButtonText.textContent = window.theme.variantStrings.addToCart;
        }
      });

      if (this.vrefAdd) this.vrefAdd.disabled = !!disable;
    }

    setUnavailable() {
      const scope = this.productWrapper || this;
      const submitButtons = scope.querySelectorAll('.single-add-to-cart-button, [data-vs-add-btn]');
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text, [data-vs-add-label]');
        if (submitButtonText) submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      const stockBlock = document.getElementById(`inventory-${this.dataset.section}`);
      if (stockBlock) stockBlock.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature == 'true') {
        this.fieldsets.forEach((fieldset) => {
          fieldset.querySelector('select')
            ? fieldset.querySelectorAll('option').forEach((opt) => { opt.disabled = opt.dataset.available === 'false'; })
            : fieldset.querySelectorAll('input').forEach((input) => { input.classList.toggle('is-disabled', input.dataset.available === 'false'); });
        });
        return true;
      }
    }
  }
  customElements.define('vs-variant-selects', VariantSelects);

  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value);
    }
  }
  customElements.define('vs-variant-radios', VariantRadios);
}if (typeof vsFormatMoney === 'undefined') {
  window.vsFormatMoney = function (cents, currency) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: currency || window.vsShopCurrency || 'USD' });
  };
}

/* Utilidades globales que el tema original referencia pero cuyo archivo fuente
   (probablemente inline en theme.liquid) no se incluyó en el material entregado.
   No son lógica de negocio: dispatchCustomEvent es un despachador de eventos
   genérico, y variantStrings son los mismos textos que ya configuras en esta
   sección (no se inventaron textos nuevos). */
if (typeof window.dispatchCustomEvent !== 'function') {
  window.dispatchCustomEvent = function (name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
  };
}
window.theme = window.theme || {};
window.theme.routes = window.theme.routes || { cart_add_url: '/cart/add.js', cart_change_url: '/cart/change.js', root_url: '/' };
window.theme.variantStrings = window.theme.variantStrings || window.__vsVariantStrings || {};

if (!window.VSWishlist) {
  (function () {
    const STORAGE_KEY = 'vs_wishlist_v1';

    function readAll() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
      } catch (e) {
        return {};
      }
    }

    function writeAll(data) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) {}
      window.dispatchEvent(new CustomEvent('vs:wishlist-change', { detail: data }));
    }

    window.VSWishlist = {
      has(id) {
        return !!readAll()[String(id)];
      },
      getAll() {
        return Object.values(readAll()).sort((a, b) => (b.addedAt || 0) - (a.addedAt || 0));
      },
      add(item) {
        if (!item || !item.id) return;
        const data = readAll();
        data[String(item.id)] = Object.assign({ addedAt: Date.now() }, item, {
          addedAt: (data[String(item.id)] && data[String(item.id)].addedAt) || Date.now()
        });
        writeAll(data);
      },
      remove(id) {
        const data = readAll();
        delete data[String(id)];
        writeAll(data);
      },
      toggle(item) {
        if (!item || !item.id) return false;
        const active = this.has(item.id);
        if (active) {
          this.remove(item.id);
        } else {
          this.add(item);
        }
        return !active;
      }
    };
  })();
}

if (!window.VSRecentlyViewed) {
  (function () {
    const STORAGE_KEY = 'vs_recent_v1';
    const MAX_ITEMS = 24;

    function readAll() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) {
        return [];
      }
    }

    function writeAll(list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (e) {}
      window.dispatchEvent(new CustomEvent('vs:recent-change', { detail: list }));
    }

    window.VSRecentlyViewed = {
      getAll() {
        return readAll().sort((a, b) => (b.viewedAt || 0) - (a.viewedAt || 0));
      },
      track(item) {
        if (!item || !item.id) return;
        const list = readAll().filter((entry) => String(entry.id) !== String(item.id));
        list.unshift(Object.assign({}, item, { viewedAt: Date.now() }));
        writeAll(list.slice(0, MAX_ITEMS));
      }
    };
  })();
}

if (!window.__vsRecentTracked && window.__vsRecentTrackData) {
  window.__vsRecentTracked = true;
  window.VSRecentlyViewed.track(window.__vsRecentTrackData);
}

if (!customElements.get('vs-pdp-product')) {
  customElements.define('vs-pdp-product', class VSPDP extends HTMLElement {
    connectedCallback() {
      this.initCardViewer();
      this.initUpsells();

      const qtyMinus = this.querySelector('[data-vs-qty-minus]');
      const qtyPlus = this.querySelector('[data-vs-qty-plus]');
      const qtyInput = this.querySelector('[data-vs-qty-input]');
      if (qtyMinus) qtyMinus.addEventListener('click', () => {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
      if (qtyPlus) qtyPlus.addEventListener('click', () => {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });

      const addBtn = this.querySelector('[data-vs-add-btn]');
      if (addBtn) addBtn.addEventListener('click', () => {
        if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;
        const variantIdInput = this.querySelector('[data-vs-selected-variant-id]');
        const variantId = variantIdInput ? variantIdInput.value : null;
        if (!variantId) return;

        const activeCard = this.querySelector('.vs-pack [data-vs-pack-card].is-selected');
        if (activeCard) {
          const quantityByVariant = new Map();
          activeCard.querySelectorAll('[data-vs-pack-variant]').forEach((select) => {
            const id = Number(select.value);
            if (!id) return;
            quantityByVariant.set(id, (quantityByVariant.get(id) || 0) + 1);
          });
          if (!quantityByVariant.size) quantityByVariant.set(Number(variantId), 1);
          const items = Array.from(quantityByVariant.entries()).map(([id, quantity]) => ({ id, quantity }));
          this.addUpsellItems(items, addBtn).catch(() => {});
          return;
        }

        this.addToCart(addBtn, variantId, parseInt(qtyInput.value, 10) || 1).catch(() => {});
      });

      const copyBtn = this.querySelector('[data-vs-copy]');
      if (copyBtn) copyBtn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          const label = copyBtn.querySelector('[data-vs-copy-label]');
          if (label) {
            label.textContent = copyBtn.dataset.copySuccess || 'Copiado';
            window.setTimeout(() => { label.textContent = copyBtn.dataset.copyDefault || 'Copiar'; }, 1400);
          }
        } catch (e) {}
      });

      const payplanOpenBtn = this.querySelector('[data-vs-payplan-open]');
      const payplanModal = this.querySelector('[data-vs-payplan-modal]');
      if (payplanOpenBtn && payplanModal) {
        const openPayplan = () => {
          payplanModal.classList.add('is-open');
          payplanModal.setAttribute('aria-hidden', 'false');
          document.body.classList.add('vs-payplan-lock');
        };
        const closePayplan = () => {
          payplanModal.classList.remove('is-open');
          payplanModal.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('vs-payplan-lock');
        };
        payplanOpenBtn.addEventListener('click', openPayplan);
        payplanModal.querySelectorAll('[data-vs-payplan-close]').forEach((btn) => {
          btn.addEventListener('click', closePayplan);
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && payplanModal.classList.contains('is-open')) closePayplan();
        });
      }

      const wishlistBtn = this.querySelector('[data-vs-wishlist]');
      if (wishlistBtn) {
        const productId = wishlistBtn.dataset.productId;
        const syncWish = () => {
          const active = window.VSWishlist.has(productId);
          wishlistBtn.classList.toggle('is-active', active);
          wishlistBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
        };
        syncWish();
        window.addEventListener('vs:wishlist-change', syncWish);
        wishlistBtn.addEventListener('click', () => {
          window.VSWishlist.toggle({
            id: productId,
            handle: wishlistBtn.dataset.productHandle,
            title: wishlistBtn.dataset.productTitle,
            url: wishlistBtn.dataset.productUrl,
            image: wishlistBtn.dataset.productImage,
            price: wishlistBtn.dataset.productPrice,
            compareAtPrice: wishlistBtn.dataset.productComparePrice,
            available: wishlistBtn.dataset.productAvailable === 'true'
          });
          syncWish();
        });
      }
    }

    addToCart(button, variantId, quantity) {
      button.classList.add('is-loading');
      button.disabled = true;

      const cart = document.querySelector('vs-cart-drawer') || document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity || 1);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map((s) => s.id || s.section));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
      }
      config.body = formData;

      return fetch(`${typeof routes !== 'undefined' ? routes.cart_add_url : '/cart/add.js'}`, config)
        .then((res) => res.json())
        .then((response) => {
          button.classList.remove('is-loading');
          button.disabled = false;

          if (response.status) {
            const label = button.querySelector('[data-vs-add-label]');
            if (label) {
              const original = label.textContent;
              label.textContent = response.description || response.message || 'No disponible';
              window.setTimeout(() => { label.textContent = original; }, 2200);
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, { source: 'vs-pdp', productVariantId: variantId, errors: response.errors || response.description, message: response.message });
            }
            return Promise.reject(response);
          }

          if (cart && typeof cart.refresh === 'function') {
            cart.refresh(true);
          } else if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          } else {
            window.location = (typeof routes !== 'undefined' && routes.cart_url) ? routes.cart_url : '/cart';
            return response;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vs-pdp', productVariantId: variantId, cartData: response });
          }

          return response;
        })
        .catch((err) => {
          button.classList.remove('is-loading');
          button.disabled = false;
          return Promise.reject(err);
        });
    }

    async addUpsellItems(items, trigger) {
      if (!items || !items.length) return;
      if (trigger) { trigger.classList.add('is-loading'); trigger.disabled = true; }
      try {
        const drawer = document.querySelector('vs-cart-drawer') || document.querySelector('cart-drawer');
        const needsSections = !(drawer && typeof drawer.refresh === 'function');
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(needsSections
            ? { items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }
            : { items: items })
        });
        const payload = await response.json();
        if (!response.ok || payload.status) throw new Error(payload.description || 'Cart error');

        if (drawer && typeof drawer.refresh === 'function') {
          try { drawer.refresh(true); } catch (e) {}
        } else if (drawer && payload.sections) {
          if (typeof drawer.renderContents === 'function') { try { drawer.renderContents(payload); } catch (e) {} }
          if (typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
        }
        const bubbleHtml = payload.sections && payload.sections['cart-icon-bubble'];
        if (bubbleHtml) {
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            const doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
            const fresh = doc.getElementById('cart-icon-bubble');
            if (fresh) bubble.innerHTML = fresh.innerHTML;
          }
        }
      } catch (e) {
        console.warn('VS upsell:', e);
      } finally {
        if (trigger) { trigger.classList.remove('is-loading'); trigger.disabled = false; }
      }
    }

    initUpsells() {
      const list = this.querySelector('[data-vs-upsell-list]');
      if (!list || list.dataset.vsInit === '1') return;
      list.dataset.vsInit = '1';

      list.addEventListener('click', (event) => {
        const variantButton = event.target.closest('[data-vs-upsell-variant]');
        if (variantButton && !variantButton.disabled) {
          const card = variantButton.closest('[data-vs-upsell-card]');
          card.querySelectorAll('[data-vs-upsell-variant]').forEach((button) => {
            const active = button === variantButton;
            button.classList.toggle('is-selected', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          const selected = card.querySelector('[data-vs-upsell-selected]');
          if (selected) { selected.value = variantButton.dataset.variantId; selected.dataset.available = variantButton.dataset.available || 'true'; }
          const price = card.querySelector('[data-vs-upsell-price]');
          const compare = card.querySelector('[data-vs-upsell-compare]');
          const saving = card.querySelector('[data-vs-upsell-savings]');
          if (price) price.textContent = variantButton.dataset.price || '';
          if (compare) {
            compare.textContent = variantButton.dataset.compare || '';
            compare.hidden = !variantButton.dataset.compare;
          }
          if (saving) {
            const pct = parseInt(variantButton.dataset.saving || '0', 10);
            saving.textContent = pct > 0 ? "Ahorras un" + ' ' + pct + '%' : '';
            saving.hidden = !(pct > 0);
          }
          return;
        }

        const addButton = event.target.closest('[data-vs-upsell-add]');
        if (addButton) {
          const card = addButton.closest('[data-vs-upsell-card]');
          const selected = card && card.querySelector('[data-vs-upsell-selected]');
          if (selected && selected.value) this.addUpsellItems([{ id: Number(selected.value), quantity: 1 }], addButton);
        }
      });

      const addAll = this.querySelector('[data-vs-upsell-add-all]');
      if (addAll) addAll.addEventListener('click', () => {
        const items = Array.from(this.querySelectorAll('[data-vs-upsell-card] [data-vs-upsell-selected]'))
          .filter((input) => input.dataset.available !== 'false')
          .map((input) => Number(input.value))
          .filter(Boolean)
          .map((id) => ({ id: id, quantity: 1 }));
        this.addUpsellItems(items, addAll);
      });
    }

    initCardViewer() {
      var pid = this.dataset.vsSection || (this.id || '').replace('vs-pdp-', '');
      var wrap = document.getElementById('pm-cc-' + pid);
      var track = document.getElementById('pm-cc-track-' + pid);
      if (!wrap || !track) return;
      var prev = wrap.querySelector('.pm-cc__prev');
      var next = wrap.querySelector('.pm-cc__next');
      var countEl = document.getElementById('pm-cc-count-' + pid);

      var items = track.querySelectorAll('.pm-cc__item');
      var total = items.length;
      if (countEl) countEl.textContent = total + ' ' + (countEl.dataset.countLabel || 'elementos');

      function itemW() {
        var it = track.querySelector('.pm-cc__item');
        if (!it) return 0;
        return it.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || '10');
      }

      function scrollByDir(dir) {
        track.scrollBy({ left: itemW() * dir * 3, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
      if (next) next.addEventListener('click', function () { scrollByDir(1); });

      track.querySelectorAll('.pm-cc__card').forEach(function (card) {
        card.addEventListener('mousemove', function (e) {
          var r = card.getBoundingClientRect();
          var px = ((e.clientX - r.left) / r.width - 0.5) * 2;
          var py = ((e.clientY - r.top) / r.height - 0.5) * 2;
          card.style.transform = 'rotateX(' + (py * -10) + 'deg) rotateY(' + (px * 10) + 'deg) scale(1.06)';
        }, { passive: true });
        card.addEventListener('mouseleave', function () { card.style.transform = ''; });
        card.addEventListener('focus', function () { card.style.transform = 'scale(1.04)'; });
        card.addEventListener('blur', function () { card.style.transform = ''; });
      });

      var isDown = false, startX, sl;
      track.addEventListener('mousedown', function (e) { isDown = true; startX = e.pageX - track.offsetLeft; sl = track.scrollLeft; });
      track.addEventListener('mouseleave', function () { isDown = false; });
      track.addEventListener('mouseup', function () { isDown = false; });
      track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        track.scrollLeft = sl - (e.pageX - track.offsetLeft - startX) * 1.2;
      });

      var autoTimer;
      function startAuto() {
        stopAuto();
        autoTimer = setInterval(function () {
          if (track.scrollLeft + track.clientWidth >= track.scrollWidth - itemW() * 0.5) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            scrollByDir(1);
          }
        }, 2800);
      }
      function stopAuto() { clearInterval(autoTimer); }

      track.addEventListener('mouseenter', stopAuto);
      track.addEventListener('mouseleave', startAuto);
      track.addEventListener('touchstart', stopAuto, { passive: true });
      track.addEventListener('touchend', function () { setTimeout(startAuto, 3000); }, { passive: true });

      var panel3d = document.getElementById('pm-cc3d-' + pid);
      var p3dClose = document.getElementById('pm-cc3d-close-' + pid);
      var p3dPrev = document.getElementById('pm-cc3d-prev-' + pid);
      var p3dNext = document.getElementById('pm-cc3d-next-' + pid);
      var p3dCounter = document.getElementById('pm-cc3d-counter-' + pid);
      var p3dStage = document.getElementById('pm-cc3d-stage-' + pid);
      var p3dItems = p3dStage ? [].slice.call(p3dStage.querySelectorAll('.pm-cc3d__item')) : [];
      var p3dIdx = 0;
      var p3dTotal = p3dItems.length;

      function p3dLayout(activeIdx) {
        var stageW = p3dStage ? p3dStage.offsetWidth : window.innerWidth;
        var visible = Math.min(2, Math.floor((p3dTotal - 1) / 2));
        var spacing = Math.min(200, stageW / (visible * 2 + 1) * 0.85);

        p3dItems.forEach(function (item, i) {
          var diff = i - activeIdx;
          if (diff > p3dTotal / 2) diff -= p3dTotal;
          if (diff < -p3dTotal / 2) diff += p3dTotal;

          var absD = Math.abs(diff);
          var imgEl = item.querySelector('img');

          var tx = diff * spacing;
          var tz = -Math.abs(diff) * 120;
          var ry = diff * -18;
          var scale = diff === 0 ? 1 : Math.max(0.6, 1 - absD * 0.18);
          var opacity = diff === 0 ? 1 : Math.max(0.25, 1 - absD * 0.3);
          var blur = diff === 0 ? 0 : absD * 1.5;
          var zIndex = 100 - absD * 10;

          item.style.transform = 'translate(-50%, -50%) translateX(' + tx + 'px) translateZ(' + tz + 'px) rotateY(' + ry + 'deg) scale(' + scale + ')';
          item.style.opacity = opacity;
          item.style.filter = blur > 0 ? 'blur(' + blur + 'px)' : '';
          item.style.zIndex = zIndex;
          item.classList.toggle('is-center', diff === 0);

          if (imgEl) {
            imgEl.style.animation = diff === 0 ? '' : 'none';
            imgEl.style.boxShadow = diff === 0
              ? '0 0 0 2.5px rgba(240,180,10,0.7), 0 20px 60px rgba(0,0,0,0.7)'
              : '0 8px 24px rgba(0,0,0,0.5)';
          }

          item.style.display = absD <= visible + 1 ? '' : 'none';
        });

        if (p3dCounter) p3dCounter.textContent = (activeIdx + 1) + ' / ' + p3dTotal;
      }

      function p3dOpen(idx) {
        p3dIdx = idx;
        if (panel3d && panel3d.parentNode !== document.body) {
          document.body.appendChild(panel3d);
        }
        panel3d.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        p3dLayout(p3dIdx);
      }

      function p3dCloseFn() {
        panel3d.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }

      function p3dGo(dir) {
        p3dIdx = (p3dIdx + dir + p3dTotal) % p3dTotal;
        p3dLayout(p3dIdx);
      }

      track.querySelectorAll('.pm-cc__card').forEach(function (card) {
        card.style.cursor = 'zoom-in';
        card.addEventListener('click', function () {
          p3dOpen(parseInt(card.dataset.index || 0));
        });
      });

      p3dItems.forEach(function (item) {
        item.addEventListener('click', function () {
          var idx = parseInt(item.dataset.idx);
          if (idx !== p3dIdx) p3dGo(idx - p3dIdx);
        });
      });

      if (p3dClose) p3dClose.addEventListener('click', p3dCloseFn);
      var p3dCloseBtn = document.getElementById('pm-cc3d-close-btn-' + pid);
      if (p3dCloseBtn) p3dCloseBtn.addEventListener('click', p3dCloseFn);
      if (p3dPrev) p3dPrev.addEventListener('click', function () { p3dGo(-1); });
      if (p3dNext) p3dNext.addEventListener('click', function () { p3dGo(1); });
      if (panel3d) panel3d.addEventListener('click', function (e) {
        if (!e.target.closest('.pm-cc3d__item') &&
            !e.target.closest('.pm-cc3d__nav') &&
            !e.target.closest('.pm-cc3d__close') &&
            !e.target.closest('.pm-cc3d__close-btn')) {
          p3dCloseFn();
        }
      });

      var p3dTouchX = null;
      if (panel3d) {
        panel3d.addEventListener('touchstart', function (e) { p3dTouchX = e.touches[0].clientX; }, { passive: true });
        panel3d.addEventListener('touchend', function (e) {
          if (p3dTouchX === null) return;
          var dx = e.changedTouches[0].clientX - p3dTouchX;
          if (Math.abs(dx) > 40) p3dGo(dx < 0 ? 1 : -1);
          p3dTouchX = null;
        }, { passive: true });
      }

      document.addEventListener('keydown', function (e) {
        if (!panel3d || !panel3d.classList.contains('is-open')) return;
        if (e.key === 'Escape') p3dCloseFn();
        if (e.key === 'ArrowLeft') p3dGo(-1);
        if (e.key === 'ArrowRight') p3dGo(1);
      });

      window.addEventListener('resize', function () {
        if (panel3d && panel3d.classList.contains('is-open')) p3dLayout(p3dIdx);
      });

      startAuto();
    }

  });
}(function () {
  
  function activeSlides(slider) {
    return Array.prototype.slice.call(slider.querySelectorAll('.product-images__slide.is-active'));
  }

  function bindZoom(slider) {
    slider.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
      if (link.dataset.zoomBound === 'true') return;
      link.dataset.zoomBound = 'true';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof openProductZoom === 'function') openProductZoom(slider, link);
      });
    });
  }

  function fallbackShow(slider, index) {
    var slides = activeSlides(slider);
    if (!slides.length) return;
    index = ((index % slides.length) + slides.length) % slides.length;
    slider.__vsFallbackIndex = index;
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-vs-current', i === index);
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });

    var wrap = slider.closest('.product-gallery-container');
    if (wrap) {
      var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('.product-thumbnail'));
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-initial-selected', i === index);
      });
      var mobileThumbs = Array.prototype.slice.call(wrap.querySelectorAll('.pm-mthumbs__item'));
      mobileThumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
    }
  }

  function setupFallback(slider) {
    if (!slider) return;

    var mq = window.matchMedia('(min-width: 900px)');

    slider.classList.add('vs-gallery-fallback');
    var slides = activeSlides(slider);
    if (!slides.length) return;
    var current = Number(slider.__vsFallbackIndex || 0);
    fallbackShow(slider, current);
    bindZoom(slider);

    var prev = slider.querySelector('.flickity-prev');
    var next = slider.querySelector('.flickity-next');

    /*
      SWIPE / DRAG EN ESCRITORIO
      Se añade sobre el controlador estable existente, sin activar Flickity
      en desktop y sin modificar la estructura de la página.
    */
    if (!slider.dataset.vsSwipeBound) {
      slider.dataset.vsSwipeBound = 'true';

      var dragStartX = 0;
      var dragStartY = 0;
      var dragMoved = false;
      var pointerActive = false;
      var wheelLocked = false;

      function beginSwipe(clientX, clientY) {
        if (!mq.matches) return;
        dragStartX = clientX;
        dragStartY = clientY;
        dragMoved = false;
        pointerActive = true;
        slider.classList.add('is-vs-dragging');
      }

      function moveSwipe(clientX, clientY) {
        if (!pointerActive || !mq.matches) return;
        var dx = clientX - dragStartX;
        var dy = clientY - dragStartY;
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
          dragMoved = true;
        }
      }

      function finishSwipe(clientX, clientY) {
        if (!pointerActive || !mq.matches) return;
        pointerActive = false;
        slider.classList.remove('is-vs-dragging');

        var dx = clientX - dragStartX;
        var dy = clientY - dragStartY;

        if (Math.abs(dx) >= 42 && Math.abs(dx) > Math.abs(dy) * 1.1) {
          var currentIndex = Number(slider.__vsFallbackIndex || 0);

          if (dx < 0) {
            fallbackShow(slider, currentIndex + 1);
          } else {
            fallbackShow(slider, currentIndex - 1);
          }
        }
      }

      slider.addEventListener('pointerdown', function(event) {
        if (!mq.matches) return;

        /* El botón de zoom sigue funcionando como botón. */
        if (event.target.closest('.product-single__media-zoom')) return;

        beginSwipe(event.clientX, event.clientY);

        try {
          if (slider.setPointerCapture && event.pointerId != null) {
            slider.setPointerCapture(event.pointerId);
          }
        } catch (e) {}
      }, { passive:true });

      slider.addEventListener('pointermove', function(event) {
        moveSwipe(event.clientX, event.clientY);
      }, { passive:true });

      slider.addEventListener('pointerup', function(event) {
        finishSwipe(event.clientX, event.clientY);
      }, { passive:true });

      slider.addEventListener('pointercancel', function() {
        pointerActive = false;
        slider.classList.remove('is-vs-dragging');
      }, { passive:true });

      /*
        Trackpad horizontal:
        un gesto lateral cambia una sola imagen y aplica un pequeño bloqueo
        para evitar saltar varias imágenes por inercia.
      */
      slider.addEventListener('wheel', function(event) {
        if (!mq.matches || wheelLocked) return;

        var dx = event.deltaX || 0;
        var dy = event.deltaY || 0;

        if (Math.abs(dx) < 24 || Math.abs(dx) <= Math.abs(dy)) return;

        event.preventDefault();

        wheelLocked = true;

        var currentIndex = Number(slider.__vsFallbackIndex || 0);

        if (dx > 0) {
          fallbackShow(slider, currentIndex + 1);
        } else {
          fallbackShow(slider, currentIndex - 1);
        }

        window.setTimeout(function() {
          wheelLocked = false;
        }, 280);
      }, { passive:false });

      /*
        Si hubo arrastre, bloqueamos solo el click fantasma que puede abrir
        accidentalmente el zoom. Un click normal sigue abriendo el zoom.
      */
      slider.addEventListener('click', function(event) {
        if (!dragMoved) return;
        event.preventDefault();
        event.stopPropagation();
        dragMoved = false;
      }, true);
    }
    if (prev && !prev.dataset.vsFallbackBound) {
      prev.dataset.vsFallbackBound = 'true';
      prev.addEventListener('click', function () {
        if (slider.flkty) return;
        fallbackShow(slider, Number(slider.__vsFallbackIndex || 0) - 1);
      });
    }
    if (next && !next.dataset.vsFallbackBound) {
      next.dataset.vsFallbackBound = 'true';
      next.addEventListener('click', function () {
        if (slider.flkty) return;
        fallbackShow(slider, Number(slider.__vsFallbackIndex || 0) + 1);
      });
    }

    var wrap = slider.closest('.product-gallery-container');
    if (wrap) {
      var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('.product-thumbnail'));
      thumbs.forEach(function (thumb, i) {
        if (thumb.dataset.vsFallbackBound) return;
        thumb.dataset.vsFallbackBound = 'true';
        thumb.addEventListener('click', function () {
          if (slider.flkty) return;
          fallbackShow(slider, i);
        });
      });
    }
  }

  function resizeFlickity(slider) {
    if (!slider || !slider.flkty) return;

    var flkty = slider.flkty;

    /*
      No recalcular ni reseleccionar mientras Flickity tiene el puntero.
      Eso era una fuente directa de rebote/doble snap.
    */
    if (flkty.isPointerDown || flkty.isDragging) return;

    try { flkty.resize(); } catch (e) {}
    try { flkty.reposition(); } catch (e) {}

    var viewport = slider.querySelector('.flickity-viewport');
    var selected = slider.querySelector('.product-images__slide.is-selected') || slider.querySelector('.product-images__slide.is-active');
    if (viewport && selected) {
      var h = selected.getBoundingClientRect().height;
      if (h > 20) viewport.style.height = Math.ceil(h) + 'px';
    }
  }

  function bootSlider(slider) {
    if (!slider) return;
    bindZoom(slider);

    /* En escritorio la galería la controla el modo estable lateral.
       Este reparador queda únicamente para tablet/móvil. */
    if (window.matchMedia('(min-width: 900px)').matches) return;

    /* Si Flickity está disponible pero el editor conectó el custom element antes de tiempo, lo arrancamos aquí. */
    if (!slider.flkty && typeof window.Flickity !== 'undefined' && typeof slider.setOptions === 'function' && typeof slider.init === 'function') {
      try {
        slider.product_container = slider.closest('.thb-product-detail');
        slider.thumbnail_container = slider.product_container ? slider.product_container.querySelector('.product-thumbnail-container') : null;
        slider.video_containers = slider.querySelectorAll('.product-single__media-external-video--play');
        slider.setOptions();
        slider.classList.remove('vs-gallery-fallback');
        slider.init();
      } catch (e) {
        console.warn('[VS gallery] Flickity init fallback:', e);
      }
    }

    if (slider.flkty) {
      slider.classList.remove('vs-gallery-fallback');
      requestAnimationFrame(function () { resizeFlickity(slider); });
      setTimeout(function () { resizeFlickity(slider); }, 80);
      setTimeout(function () { resizeFlickity(slider); }, 350);
      setTimeout(function () { resizeFlickity(slider); }, 900);
    } else {
      setupFallback(slider);
    }

    slider.querySelectorAll('.product-single__media-image img').forEach(function (img) {
      if (img.dataset.vsDesktopRepairBound) return;
      img.dataset.vsDesktopRepairBound = 'true';
      img.addEventListener('load', function () {
        if (slider.flkty) resizeFlickity(slider);
        else setupFallback(slider);
      });
    });
  }

  function repair(root) {
    root = root || document;
    var selector = '[id^="Product-Slider-"]';
    var slider = root.querySelector ? root.querySelector(selector) : null;
    if (!slider) slider = document.querySelector('[id^="Product-Slider-"]');
    if (!slider) return;
    bootSlider(slider);

    if (!slider.__vsResizeObserver && typeof ResizeObserver !== 'undefined') {
      slider.__vsResizeObserver = new ResizeObserver(function () {
        if (!slider.flkty) return;

        window.clearTimeout(slider.__vsResizeTimer);
        slider.__vsResizeTimer = window.setTimeout(function () {
          if (!slider.flkty || slider.flkty.isPointerDown || slider.flkty.isDragging) return;
          resizeFlickity(slider);
        }, 90);
      });

      slider.__vsResizeObserver.observe(slider);

      var container = slider.closest('.product-image-container');
      if (container) slider.__vsResizeObserver.observe(container);
    }
  }

  function scheduleRepair(root) {
    requestAnimationFrame(function () {
      repair(root);
      setTimeout(function () { repair(root); }, 100);
      setTimeout(function () { repair(root); }, 500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleRepair(document); }, { once: true });
  } else {
    scheduleRepair(document);
  }

  window.addEventListener('load', function () { scheduleRepair(document); }, { once: true });
  window.addEventListener('resize', function () { scheduleRepair(document); }, { passive: true });

  /* Shopify Theme Editor vuelve a montar secciones sin recargar la página. */
  document.addEventListener('shopify:section:load', function (event) { scheduleRepair(event.target || document); });
  document.addEventListener('shopify:section:select', function (event) { scheduleRepair(event.target || document); });
  document.addEventListener('shopify:block:select', function (event) { scheduleRepair(event.target || document); });

  /* Si el CDN de Flickity tarda, pasamos de fallback a Flickity cuando aparezca. */
  var attempts = 0;
  var timer = window.setInterval(function () {
    attempts += 1;
    repair(document);
    var slider = document.querySelector('[id^="Product-Slider-"]');
    if ((slider && slider.flkty) || attempts >= 30) window.clearInterval(timer);
  }, 150);
})();/* VS STABLE LAYOUT + MAIN SWIPE NO ARROWS */
(function () {
  var mq = window.matchMedia('(min-width: 900px)');
  var root = null;
  var slider = null;
  var thumbObserver = null;
  var currentIndex = 0;

  function getSlides() {
    if (!slider) return [];
    return Array.prototype.slice.call(
      slider.querySelectorAll('.product-images__slide.is-active')
    );
  }

  function getThumbs() {
    if (!root) return [];
    return Array.prototype.slice.call(
      root.querySelectorAll('[id^="Product-Thumbnails-"]' + ' .product-thumbnail')
    );
  }

  function mediaId(el) {
    var value = el && el.getAttribute ? (el.getAttribute('data-media-id') || '') : '';
    return value.split('-').pop();
  }

  function indexFromTarget(target) {
    var slides = getSlides();
    if (!slides.length) return 0;

    if (typeof target === 'number' && isFinite(target)) return target;

    if (typeof target === 'string') {
      var found = null;
      try { found = slider.querySelector(target); } catch (e) {}
      if (!found) {
        var raw = String(target).replace(/^#/, '');
        found = slides.find(function (slide) {
          return slide.id === raw || mediaId(slide) === raw || slide.getAttribute('data-media-id') === raw;
        });
      }
      var idx = slides.indexOf(found);
      if (idx > -1) return idx;
    }

    if (target && target.nodeType === 1) {
      var nodeIdx = slides.indexOf(target);
      if (nodeIdx > -1) return nodeIdx;
    }

    return currentIndex || 0;
  }

  function select(index, fromThumbObserver) {
    if (!slider || !mq.matches) return;
    var slides = getSlides();
    var thumbs = getThumbs();
    if (!slides.length) return;

    index = Number(index);
    if (!isFinite(index)) index = 0;
    index = ((index % slides.length) + slides.length) % slides.length;
    currentIndex = index;

    slides.forEach(function (slide, i) {
      var active = i === index;
      slide.classList.toggle('is-vs-current', active);
      slide.classList.toggle('is-selected', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      slide.style.setProperty('display', active ? 'block' : 'none', 'important');
      slide.style.setProperty('position', 'relative', 'important');
      slide.style.setProperty('transform', 'none', 'important');
      slide.style.setProperty('left', 'auto', 'important');
      slide.style.setProperty('width', '100%', 'important');
    });

    if (!fromThumbObserver) {
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-initial-selected', i === index);
      });
    }

    var activeThumb = thumbs[index];
    if (activeThumb && activeThumb.parentElement) {
      try {
        activeThumb.parentElement.scrollTo({
          top: Math.max(0, activeThumb.offsetTop - 10),
          behavior: 'smooth'
        });
      } catch (e) {}
    }
  }

  function destroyFlickitySafely() {
    if (!slider) return;
    try {
      if (slider.flkty && typeof slider.flkty.destroy === 'function') slider.flkty.destroy();
    } catch (e) {}
    slider.flkty = null;
    slider.classList.remove('flickity-enabled');
  }

  function bindDesktop() {
    if (!mq.matches) return;

    root = document.querySelector('vs-pdp-product');
    if (!root) return;
    slider = root.querySelector('[id^="Product-Slider-"]');
    if (!slider) return;

    destroyFlickitySafely();
    slider.classList.add('vs-desktop-reference');
    slider.classList.remove('vs-gallery-fallback');

    var slides = getSlides();
    var thumbs = getThumbs();
    if (!slides.length) return;

    var selectedThumbIndex = thumbs.findIndex(function (thumb) {
      return thumb.classList.contains('is-initial-selected');
    });
    if (selectedThumbIndex > -1) currentIndex = selectedThumbIndex;

    /* Método usado por variantes / otras funciones de la sección. */
    slider.vsDesktopSelect = function (target) {
      select(indexFromTarget(target), false);
    };
    slider.selectCell = function (target) {
      select(indexFromTarget(target), false);
    };

    var prev = slider.querySelector('.flickity-prev');
    var next = slider.querySelector('.flickity-next');

    if (prev && !prev.dataset.vsDesktopReferenceBound) {
      prev.dataset.vsDesktopReferenceBound = 'true';
      prev.addEventListener('click', function (event) {
        if (!mq.matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        select(currentIndex - 1, false);
      }, true);
    }

    if (next && !next.dataset.vsDesktopReferenceBound) {
      next.dataset.vsDesktopReferenceBound = 'true';
      next.addEventListener('click', function (event) {
        if (!mq.matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        select(currentIndex + 1, false);
      }, true);
    }

    thumbs.forEach(function (thumb, index) {
      if (thumb.dataset.vsDesktopReferenceBound) return;
      thumb.dataset.vsDesktopReferenceBound = 'true';
      thumb.addEventListener('click', function (event) {
        if (!mq.matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        select(index, false);
      }, true);
    });

    /* Cuando una variante cambia la miniatura activa, mostrar su imagen. */
    if (thumbObserver) thumbObserver.disconnect();
    var thumbContainer = root.querySelector('[id^="Product-Thumbnails-"]');
    if (thumbContainer && typeof MutationObserver !== 'undefined') {
      thumbObserver = new MutationObserver(function () {
        if (!mq.matches) return;
        var list = getThumbs();
        var idx = list.findIndex(function (thumb) {
          return thumb.classList.contains('is-initial-selected');
        });
        if (idx > -1 && idx !== currentIndex) select(idx, true);
      });
      thumbObserver.observe(thumbContainer, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }

    select(currentIndex, false);
  }

  function releaseDesktop() {
    if (thumbObserver) {
      thumbObserver.disconnect();
      thumbObserver = null;
    }
    if (!slider) return;

    slider.classList.remove('vs-desktop-reference');
    getSlides().forEach(function (slide) {
      slide.classList.remove('is-vs-current', 'is-selected');
      slide.style.removeProperty('display');
      slide.style.removeProperty('position');
      slide.style.removeProperty('transform');
      slide.style.removeProperty('left');
      slide.style.removeProperty('width');
      slide.removeAttribute('aria-hidden');
    });
  }

  function syncMode() {
    if (mq.matches) {
      bindDesktop();
      window.setTimeout(bindDesktop, 60);
      window.setTimeout(bindDesktop, 250);
    } else {
      releaseDesktop();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMode, { once: true });
  } else {
    syncMode();
  }

  window.addEventListener('load', syncMode, { once: true });
  mq.addEventListener ? mq.addEventListener('change', syncMode) : mq.addListener(syncMode);

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target || !event.target.querySelector) return;
    if (event.target.querySelector('vs-pdp-product') || (event.target.tagName === 'VS-PDP-PRODUCT')) {
      window.setTimeout(syncMode, 20);
    }
  });

  document.addEventListener('shopify:section:select', function () {
    window.setTimeout(syncMode, 20);
  });
})();(function(){
  var BREAKPOINT = 900;
  var main = document.querySelector('vs-pdp-product');
  if(!main) return;

  var stack = main.querySelector('[data-vs-pdp-desktop-stack]');
  if(!stack) return;

  function detailWrapper(){
    return document.querySelector('.vs-pdp-section-02');
  }

  function upsellWrapper(){
    return document.querySelector('.vs-pdp-section-03');
  }

  function detailNode(){
    var wrapper = detailWrapper();
    return wrapper ? wrapper.querySelector('[id^="vs-detail-"]') : null;
  }

  function upsellNode(){
    var wrapper = upsellWrapper();
    return wrapper ? wrapper.querySelector('[id^="vs-up-"]') : null;
  }

  function rememberPlace(node){
    if(!node || node.__vsPdpInnerMarker) return;

    var marker = document.createComment(
      'VS PDP inner original position: ' + (node.id || node.className || 'content')
    );

    if(node.parentNode){
      node.parentNode.insertBefore(marker,node);
      node.__vsPdpInnerMarker = marker;
    }
  }

  function sourceWrapperFor(node){
    if(!node || !node.__vsPdpInnerMarker) return null;
    return node.__vsPdpInnerMarker.parentNode;
  }

  function markSource(node,isDocked){
    var wrapper = sourceWrapperFor(node);
    if(!wrapper) return;

    /*
      El wrapper Shopify queda donde Shopify espera encontrarlo.
      Solo ocultamos su caja vacía mientras el contenido está montado
      en la columna derecha.
    */
    var shopifySection = wrapper.closest('.shopify-section') || wrapper;
    shopifySection.classList.toggle('vs-pdp-source-is-docked',!!isDocked);
  }

  function dockNode(node,kind){
    if(!node) return;

    rememberPlace(node);

    if(node.parentNode !== stack){
      stack.appendChild(node);
    }

    node.setAttribute('data-vs-pdp-docked',kind);
    markSource(node,true);
  }

  function restoreNode(node){
    if(!node || !node.__vsPdpInnerMarker) return;

    var marker = node.__vsPdpInnerMarker;

    if(marker.parentNode){
      marker.parentNode.insertBefore(node,marker.nextSibling);
    }

    node.removeAttribute('data-vs-pdp-docked');
    markSource(node,false);
  }

  function findDocked(kind){
    return stack.querySelector('[data-vs-pdp-docked="' + kind + '"]');
  }

  function dock(){
    var desktop = window.innerWidth >= BREAKPOINT;

    var detail = detailNode() || findDocked('detail');
    var upsell = upsellNode() || findDocked('upsell');

    if(desktop){
      if(detail) dockNode(detail,'detail');
      if(upsell) dockNode(upsell,'upsell');
    }else{
      if(detail) restoreNode(detail);
      if(upsell) restoreNode(upsell);
    }
  }

  var raf = 0;
  function scheduleDock(){
    if(raf) cancelAnimationFrame(raf);

    raf = requestAnimationFrame(function(){
      raf = 0;
      dock();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',scheduleDock,{once:true});
  }else{
    scheduleDock();
  }

  window.addEventListener('load',scheduleDock,{once:true});
  window.addEventListener('resize',scheduleDock,{passive:true});

  /*
    Shopify Theme Editor:
    PDP 02 / PDP 03 pueden volver a renderizarse.
    Recalculamos sin mover nunca el wrapper .shopify-section.
  */
  document.addEventListener('shopify:section:load',function(){
    window.setTimeout(scheduleDock,20);
  });

  document.addEventListener('shopify:section:select',function(){
    window.setTimeout(scheduleDock,20);
  });

  document.addEventListener('shopify:section:reorder',function(){
    window.setTimeout(scheduleDock,20);
  });

  if(typeof MutationObserver !== 'undefined'){
    var observer = new MutationObserver(function(mutations){
      var shouldSchedule = false;

      mutations.forEach(function(mutation){
        if(mutation.addedNodes && mutation.addedNodes.length){
          shouldSchedule = true;
        }
      });

      if(shouldSchedule){
        window.clearTimeout(observer.__vsTimer);
        observer.__vsTimer = window.setTimeout(scheduleDock,30);
      }
    });

    observer.observe(document.body,{
      childList:true,
      subtree:true
    });
  }
})();